import { Button, Tooltip } from "antd";
import { DeleteOutlined, InfoCircleOutlined, PhoneOutlined } from "@ant-design/icons";

const LeadActions = ({ record, onShowInfo, onUpdateStatus, onBackToLeads }) => {
  return (
    <div style={{ display: "flex", gap: 4, whiteSpace: "nowrap" }}>
      {record.id && (
        <Tooltip title="اطلاعات لید">
          <Button icon={<InfoCircleOutlined />} type="default" onClick={() => onShowInfo(record)} />
        </Tooltip>
      )}
      {record.status === 0 && (
        <Tooltip title="تماس گرفته شد">
          <Button icon={<PhoneOutlined />} type="primary" onClick={() => onUpdateStatus(record, 1)} />
        </Tooltip>
      )}
      {record.status === 0 && record.reportCount === 0 && (
        <Tooltip title="حذف از لیدهای من">
          <Button icon={<DeleteOutlined />} type="default" danger onClick={() => onBackToLeads(record)} />
        </Tooltip>
      )}
    </div>
  );
};

export default LeadActions;
